import { Box, Stack } from "@mui/material";
import React from "react";
import { Color } from "../../constants";

const FettiLabeledCheckbox = ({
  label,
  value,
  onClick,
  size = "13px",
  ...props
}) => {
  const [hovered, setHovered] = React.useState(false);
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={0.5}
      sx={{
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}>
      <input
        type="checkbox"
        checked={value}
        {...props}
        onChange={onClick}
        style={{
          cursor: "pointer",
          width: size,
          height: size,
          minWidth: size,
          ...(hovered && {
            boxShadow: `0px 0px 2px 2px ${Color.lightBlue}`,
            // backgroundColor: Color.fettiLightBlue,
            // webkitAppearance: "none",
            // mozAppearance: "none",
            // appearance: "none",
            // border: "1px solid #666",
            // borderRadius: "2px",
            // backgroundColor: Color.fettiLightBlue,
          }),
        }}
      />
      <Box sx={{ fontSize: "14px", color: "#333" }}> {label}</Box>
    </Stack>
  );
};

export default FettiLabeledCheckbox;
